import { Alert, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  bookingConfirmBlock,
  confirmBlockPassengerFields,
} from '../bookingState';
import type { BookingActionState } from '../bookingState';

interface Props {
  booking: BookingActionState;
}

/** Aviso durable compartido por las dos vistas de una reserva. */
export function ConfirmPassengerContractWarning({ booking }: Props) {
  const { t } = useTranslation();
  if (!bookingConfirmBlock(booking)) return null;

  const fields = confirmBlockPassengerFields(booking);
  return (
    <Alert severity="warning">
      <Typography component="strong" display="block">
        {t('travelServices.booking.confirmBlockTitle')}
      </Typography>
      {t('travelServices.booking.confirmBlockNotice')}
      {fields.length > 0 && (
        <Box component="ul" sx={{ mb: 0, mt: 1, pl: 3 }}>
          {fields.map(({ ref, field, scope }) => (
            <li key={ref}>
              {t('travelServices.booking.confirmBlockField', {
                field: t(`travelServices.booking.paxFields.${field}`),
                scope: t(`travelServices.booking.fieldScope.${scope}`),
              })}
            </li>
          ))}
        </Box>
      )}
    </Alert>
  );
}
